/* 📧 email hard-gate check — a trade may only fire when an email is on file
   (saved on this device, or server-known for this account). */
export const emailOnFile = () => {
  try {
    return (localStorage.getItem("vts_email_optin_v1") || "").includes("@") ||
           localStorage.getItem("vts_email_known_v1") === "1";
  } catch {
    return true; // storage blocked (private mode) — never brick the app
  }
};

export const requireEmail = () => {
  if (emailOnFile()) return true;
  try { window.dispatchEvent(new Event("vts-open-email-gate")); } catch { /* noop */ }
  return false;
};
